export default __webpack_public_path__ + "static/kb_3_7-76eff88678668fef819109189736f2c6.jpg";